export default {
  // 取消订单_张逸玮
  cancelOrder(params) {
    return app.http.ajax({
      method: 'post',
      url: `/mall-portal/orderInfo/cancelOrder`,
      params,
    });
  },
  // 物品列表（学员端）_宁佐坤
  studentGoodsList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/mall-portal/commodityGoods/studentGoodsList',
      params,
    });
  },
  // 商品物品详情(学员端)_宁佐坤
  studentGoodsDetails(params) {
    return app.http.ajax({
      method: 'get',
      url: '/mall-portal/commodityGoods/studentGoodsDetails',
      params,
    });
  },
  // 商品列表_李祥达
  queryCommodityPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/mall-portal/commodity/page',
      params,
    });
  },
  // 商品详情_李祥达
  queryCommodityGet(params) {
    return app.http.ajax({
      method: 'get',
      url: '/mall-portal/commodity/get',
      params,
    });
  },
  // 获取分享信息_伍志长
  getCommodityShareInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/mall-portal/common/getShareInfo',
      params,
    });
  },
  // 增加分享链接的浏览量_伍志长
  addPageviews(params) {
    return app.http.ajax({
      method: 'post',
      url: '/mall-portal/common/addPageviews',
      params,
    });
  },
  // 校区列表（免登录）_杨武
  queryCampus(params) {
    return app.http.ajax({
      method: 'get',
      url: '/mall-portal/campus',
      params,
    });
  },

  // 获取物品库存
  checkStudentGoodsStock(params) {
    return app.http.ajax({
      method: 'POST',
      url: '/mall-portal/commodityGoods/getStudentGoodsCampusStock',
      params,
    });
  },

  // 订单创建_刘鹏
  createOrder(params) {
    return app.http.ajax({
      method: 'post',
      url: '/mall-portal/orderInfo',
      params,
    });
  },
  // 订单支付_刘鹏
  orderInfoPayment(params) {
    return app.http.ajax({
      method: 'post',
      url: '/mall-portal/orderInfo/onlinePayment',
      params,
    });
  },
  // 订单状态_王杰
  getOrderStatus(params) {
    return app.http.ajax({
      method: 'get',
      url: '/mall-portal/orderInfo/status',
      params,
    });
  },
};
